import React from 'react';
import {ConfigFieldDefinitionBase} from './config-field-definition-base';
import {NumericDropDownValueEditorComponent} from '../../../components/value-editors/numeric-drop-down-value-editor/numeric-drop-down-value-editor.component';

export interface NumericDropDownItem {
    value: number,
    text?: string;
}


export class NumericDropDownFieldDefinition extends ConfigFieldDefinitionBase {
    constructor(title: string, description: string, private _items: NumericDropDownItem[]) {
        super(title, description);
    }

    render() {
        return (<NumericDropDownValueEditorComponent key={this.configurationKey}
                                                     fieldDefinition={this}
                                                     items={this._items}/>)
    }
}